import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import close from 'assets/icons/close.png'
import { getImages, postImages } from 'service/BackgroundService'
import Notification from 'utils/Notifications'
import styles from './ChangeBackground.module.scss'

export default function ChangeBackground({ setOpenModal }) {
  const { t } = useTranslation('common')
  const [data, setData] = useState([])
  const [id, setId] = useState(null)

  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  })

  useEffect(() => {
    let mounted = true
    const getData = async () => {
      try {
        const response = await getImages()
        if (mounted) setData(response?.data || [])
      } catch (error) {
        if (mounted) {
          setNotify({
            isOpen: true,
            message: t('components.changeBackground.load_error', 'Не удалось загрузить темы'),
            type: 'error',
            sound: 'error',
          })
        }
      }
    }
    getData()
    return () => {
      mounted = false
    }
  }, [t])

  const handleSubmit = async () => {
    if (id === null) {
      setNotify({
        isOpen: true,
        message: t('components.changeBackground.select_image'),
        type: 'warning',
        sound: 'warning',
      })
      return
    }
    try {
      const response = await postImages({ file_id: id })
      try {
        localStorage.setItem('background', response?.data?.file || '')
      } catch (_) {
        /* ignore */
      }
      // Сообщаем другим компонентам о смене фона.
      try {
        window.dispatchEvent(new CustomEvent('background:changed', {
          detail: { file: response?.data?.file },
        }))
      } catch (_) {
        /* ignore */
      }
      setOpenModal(false)
    } catch (error) {
      setNotify({
        isOpen: true,
        message: t('components.changeBackground.save_error', 'Не удалось сохранить'),
        type: 'error',
        sound: 'error',
      })
    }
  }

  return (
    <div className={styles.background_wrapper}>
      <div className={styles.background_header}>
        <p>{t('components.changeBackground.themes')}</p>
        <button
          type="button"
          className={styles.close_img}
          onClick={() => setOpenModal(false)}
          aria-label={t('ui.close_aria', 'Закрыть')}
        >
          <img src={close} alt="" aria-hidden="true" />
        </button>
      </div>
      <div className={styles.background_body}>
        {data?.map((item) => (
          <div
            key={item?.id}
            role="button"
            tabIndex={0}
            aria-pressed={id === item?.id}
            className={
              id === item?.id
                ? styles.background_child_active
                : styles.background_child
            }
            onClick={() => setId(item?.id)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                setId(item?.id)
              }
            }}
          >
            <img
              src={item?.file}
              alt={t('components.changeBackground.theme_alt', 'Тема оформления')}
              className={styles.background_img}
            />
          </div>
        ))}
      </div>
      <div className={styles.background_footer}>
        <button type="button" className={styles.save_btn} onClick={handleSubmit}>
          {t('common.save')}
        </button>
        <button type="button" className={styles.cancel} onClick={() => setOpenModal(false)}>
          {t('common.cancel')}
        </button>
      </div>
      <Notification notify={notify} setNotify={setNotify} />
    </div>
  )
}
